
import { defineComponent } from 'vue'
import { MDBBtn, MDBBtnGroup, MDBIcon } from 'mdb-vue-ui-kit'
export default defineComponent({
  name: 'MediaBar',
  components: { MDBBtn, MDBBtnGroup, MDBIcon }
})
